import EventEmitter3 from 'eventemitter3'

export const EVENT_SHOW_LOGIN_MODAL = 'EventShowLoginModal'
export const EVENT_CENTER_MAP_ON_POSITION = 'EventCenterMapOnPosition'

const eventEmitter = new EventEmitter3()

export default eventEmitter
